module.exports = __webpack_public_path__ + "img/banlance_bg.48629c5e.png";